import { FloraButton } from '@grupoboticario/flora-react';
import { catalog, type RootState } from 'core';
import { useSelector } from 'react-redux';
import { Container, Layout, ProductListSkeleton } from 'ui/components';
import { useCallback } from 'ui/utilities';

import type { ProductsPaginationProps } from './Products.d';

const ProductsPagination = ({ anchorId }: ProductsPaginationProps) => {
  const { getNextPage } = catalog.commands.useCatalogCommand();

  const {
    data: { hasNextPage, nextPage },
    isLoading,
  } = catalog.hooks.usePagination();

  const queryOptions = useSelector((state: RootState) => state.catalog.queryOptions);

  const handleOnClick = useCallback(() => {
    getNextPage({ ...queryOptions, page: nextPage });
  }, [nextPage, queryOptions]);

  if (isLoading) {
    return (
      <Container fluid marginTop="sp-2">
        <ProductListSkeleton itemsPerRowDesktop={4} />
      </Container>
    );
  }

  return (
    <Container fluid marginTop="sp-8">
      <Layout horizontalAlign="center">
        {hasNextPage && (
          <FloraButton onClick={handleOnClick} hierarchy="secondary">
            Carregar mais produtos
          </FloraButton>
        )}
      </Layout>
    </Container>
  );
};

export default ProductsPagination;
